import _ from "lodash";
import {JobTypes} from "../constants/Request";
import {UserRoles} from "../constants/UserRoles";

export default class UserUtils {
  static transformUserInfo = (user, ignoreUserAccessDetails = false) => {
    let updatedUser = {};
    if (!ignoreUserAccessDetails) {
      // Below line is the temp fix and we will get the uid from OKTA.
      updatedUser["uid"] = _.get(user, "sAMAccountName");
      updatedUser["oktaUid"] = _.get(user, "sub");
      updatedUser["sAMAccountName"] = _.get(user, "sAMAccountName");
      updatedUser["fullName"] = _.get(user, "given_name") + " " + _.get(user, "family_name");
      updatedUser["email"] = _.get(user, "email");
      updatedUser["role"] = _.get(user, "role", "");
    }
    // Deptname should be array and user can belong more than one dapartment.
    updatedUser["deptName"] = _.get(user, "department", "MSE");
    updatedUser["userDepartments"] = _.get(user, "userDepartments",[]);
    return updatedUser;
  };
  
  static transformAssignee = (user) => {
    let newUser = {};
    newUser["fullName"] = _.get(user, "FirstName") + " " + _.get(user, "LastName");
    newUser["role"] = _.get(user, "role");
    newUser["uid"] = _.get(user, "SAMAccountName");
    newUser["oktaUid"] = _.get(user, "ID");
    newUser["sAMAccountName"] = _.get(user, "SAMAccountName");
    newUser["email"] = _.get(user, "Email");
    newUser["deptName"] = _.get(user, "Department[0]");
    return newUser;
  };

  static getRoleFromConfig(opsGrp) {
    return _.isEmpty(opsGrp) ? "" : UserUtils.getRole(opsGrp.join(","));
    //Hard code userRole here for checking in front end
    //return "requestor";
  }

  static getUser = (userInfm, lists) => {
    let userVal = _.find(lists, ["SAMAccountName", _.get(userInfm, "sAMAccountName")]);
    return {
      ...userInfm,
      department: _.get(userVal, "Department[0]"),
      userDepartments: _.get(userVal, "Department"),
      //Below code get role from user api call
      role: UserUtils.getRoleFromConfig(_.get(userInfm, "ops.morph.groups", ["ops"])),
    };
  };

  static sortArray(array) {
    return array.sort(function (a, b) {
      return a.toLowerCase().localeCompare(b.toLowerCase());
    });
  }

  static getRole(groups) {
    let userRole;
    if (_.includes(groups, "AdminWithReadAccess")) {
      userRole = "adminwithreadaccess";
    } else if (_.includes(groups, "Ops")) {
      userRole = "ops";
    } else if (_.includes(groups, "Requestor")) {
      userRole = "requestor";
    } else if (_.includes(groups, "GlobalAdmin")) {
      userRole = "globaladmin";
    } else if (_.includes(groups, "SuperAdmin")) {
      userRole = "superadmin";
    } else if (_.includes(groups, "Admin")) {
      userRole = "admin";
    } else if (_.includes(groups, "CR_API")) {
      userRole = "cr_api";
    } else if (_.includes(groups, "MediaRequest")) {
      userRole = "mediarequest";
    } else if (_.includes(groups, "Legacy_GMSC")) {
      userRole = "legacygmsc";
    } else {
      userRole = "";
    }
    return userRole;
  }

  static transformGrp(lists) {
    return _.map(lists, (val) => {
      val.role = UserUtils.getRole(val.AssignedGroups);
      return val;
    });
  }

  static getAssignee(list) {
    let newList = _.filter(list, ({role}) => role === UserRoles.OPS || role === UserRoles.SUPERADMIN || role === UserRoles.GLOBALADMIN || role === UserRoles.ADMIN);
    let finalList = _.map(newList, (val) => {
      return UserUtils.transformAssignee(val);
    });
    return _.sortBy(_.uniqBy(finalList, "oktaUid"), (user) => _.get(user, "fullName").toLowerCase());
  }

  static getDepartments(list) {
    let arr = [];
    arr = _.values(_.mapValues(list, "Department"));
    let uniqVal = _.uniq(_.flatten(arr));
    return UserUtils.sortArray(uniqVal);
  }

  static getFilterDept(department) {
    return _.map(department, (dept) => {
      return { value: dept, label: dept };
    });
  }

  static getFilterAssignee(assignee) {
    return _.map(assignee, (user) => {
      return { value: user.oktaUid, label: user.fullName };
    });
  }

  static isJobTypeAccessible = (userRole, jobType) => {
    return (jobType === JobTypes.CONTENT_REQUEST_API && (userRole === UserRoles.CR_API || userRole === UserRoles.GLOBALADMIN))
        || (jobType !== JobTypes.CONTENT_REQUEST_API && userRole !== UserRoles.CR_API);
  }
}
